module.exports = __webpack_public_path__ + "img/payment-mastercard.00b3a956.png";